import { Badge, Skeleton } from '@ashniva/ui';

import { freshnessText } from '../freshness';
import { problemShortLabel } from '../problem-copy';
import { classifyProblem } from '../ri-problems';
import { useNow } from '../use-now';
import { useRepositoryState } from '../use-repository-state';
import { StateBadge } from './RepositoryStateView';

/**
 * One repository's state in a list (P14-02): the lifecycle as a word, and how fresh the index is. Read once, never
 * followed: the repository's own page follows a registration in flight.
 */
export function RepositoryStatusCell({ linkId }: { linkId: string }) {
  const { isLoading, error, state } = useRepositoryState(linkId, false);
  const now = useNow();
  if (isLoading) {
    return (
      <span aria-busy="true">
        <span className="sr-only">Loading its state</span>
        <Skeleton width="8rem" />
      </span>
    );
  }
  if (error || !state) {
    return <Badge tone="neutral">{problemShortLabel(classifyProblem(error))}</Badge>;
  }
  return (
    <span className="ri-row">
      <StateBadge kind={state.kind} />
      {state.kind === 'ready' || state.kind === 'stale' ? (
        <span className="ri-muted">{freshnessText(state.indexedCommit, state.indexedAt, now)}</span>
      ) : null}
    </span>
  );
}
